import * as THREE from "three";
import { GetRangeKey } from "./Common";
import { SetTreeTransArr } from "./TransControl";
import { ChangeTreeSize, SetObstPosition, ToggleSelectedTreeDelete, ChangeSelectedTreeShape } from "./ObstructionControl";
import { SetSelModuleArr,
    AddIndividualMode,
    addModulesToAllRoofsMaxFill,
    addModulesToRoofAutoFill,
    SwitchModuleIrrMat
} from "./ModuleControl";
import { treeList } from "../../../../../Constants";
import { useViewerStore } from "../../../../../store/store";
import {drawDesign} from "./Loader";
import {SelectFlatRoof, UpdatePlaneRoof} from "./PlaneRoofControls";
import {addSelectedTree} from "../../../../../helpers/storeHelpers";
import { Viewer } from "../Viewer-Factory/Viewer";
import { CustomImageProperty, HideObjectType, ObstProperty } from "../../../../../@types/enums";
import { ModuleMesh } from "../../../../../@types/types";
export function InitStep(self: Viewer) {
    self.stepArr = [];
    self.stepMax = -1;
    self.stepNum = -1;
    SetStepButton(self.stepMax, self.stepNum);
}

export function AddStep(self: Viewer, key: string, object: any, older?: any, newer?: any) {
    self.stepNum++;
    self.stepArr[self.stepNum] = { key, object, older, newer };
    self.stepMax = self.stepNum;
    SetStepButton(self.stepMax, self.stepNum);
}

export function SetStep(self: Viewer, stepDir: number) {
    // const {stepArr, stepNum, stepMax} = self;
    if (self.stepNum === -1 && stepDir === -1) return;
    if (self.stepNum === self.stepMax && stepDir === 1) return;
    const { treeGroup, obstGroup, roofRotY } = self;
    var stepInfo;
    if (stepDir === -1) {
        stepInfo = self.stepArr[self.stepNum];
    } else {
        stepInfo = self.stepArr[self.stepNum + 1];
    }
    if (!stepInfo) return;
    const { key, object, older, newer } = stepInfo;

    if (key === 'WallHeight') {
        const wallHeight = (stepDir === -1 ? older : newer);
        self.setWallSize(wallHeight);
        useViewerStore.setState({ wallEditedHeight: wallHeight });
    } else if (key.includes('customImage')) {
        const realKey = GetRangeKey(key) as CustomImageProperty;
        const stepValue = stepDir === -1 ? older : newer;
        self.updateCustomImageProperty(realKey, stepValue);
    } else if (key === "GhostTree") {
        const selGroup = (stepDir === -1 ? older : newer);
        const selGroupIds = selGroup.map((group: any) => group.obstId);
        if (useViewerStore.getState().isHideAllGhostTrees) {
            self.hideObject(HideObjectType.GhostTree, !useViewerStore.getState().isHideAllGhostTrees);
            useViewerStore.setState({ isHideAllGhostTrees: !useViewerStore.getState().isHideAllGhostTrees });
        }
        self.selTreeArr = treeGroup.children.filter((group: any) => selGroupIds.includes(group.obstId));
        ToggleSelectedTreeDelete(self)
    } else if (key === "GhostTreeAndCart") {
        const selGroup = (stepDir === -1 ? older : newer);
        const selGroupIds = selGroup.treeArr.map((group: any) => group.obstId);
        if (useViewerStore.getState().isHideAllGhostTrees) {
            self.hideObject(HideObjectType.GhostTree, !useViewerStore.getState().isHideAllGhostTrees);
            useViewerStore.setState({ isHideAllGhostTrees: !useViewerStore.getState().isHideAllGhostTrees });
        }
        self.selTreeArr = treeGroup.children.filter((group: any) => selGroupIds.includes(group.obstId));
        ToggleSelectedTreeDelete(self)
        useViewerStore.setState({ treeCartItems: selGroup.cartArr });
    } else if (key === "GhostObstruction") {
        const delStatus = (stepDir === -1 ? older : newer);
        self.obstId = object;
        self.setObstDelete();
    } else if (key === 'TreeShape') {
        const treeType = (stepDir === -1 ? older : newer);
        object.forEach((treeId: any, idx: number) => {
            const selTree = treeGroup.children.find((tree: any) => tree.obstId === treeId);
            if (!selTree) return;
            let currentType = treeType[idx] || "crown1"
            let newType = treeList.find(item => item.cM === currentType);
            if (!newType) return;
            ChangeSelectedTreeShape(self, newType)
        });
    } else if (key.includes('Obst')) {
        //self.obstId = undefined;
        const realKey = GetRangeKey(key);
        const stepValue = stepDir === -1 ? older : newer;
        self.obstId = object;
        self.setObstProperty(realKey as ObstProperty, stepValue[0])
        useViewerStore.setState({ obstUpdated: !useViewerStore.getState().obstUpdated });
        //self.obstId = undefined;
    } else if (key.includes('Tree')) {
        // SetTreeTransArr(self, true);
        object.forEach((obstId: any) => {
            const treeObj: any = treeGroup.children.find((tree: any) => tree.obstId === obstId);
            if (!treeObj) return;
            treeObj.select = true;
            addSelectedTree(treeObj);
        });
        SetTreeTransArr(self);
        const stepValue = stepDir === -1 ? older : newer;
        const realKey = GetRangeKey(key);
        ChangeTreeSize(self, realKey, stepValue);
        self.refreshShade();
        // SetTreeTransArr(self, true);
    } else if (key === 'obstMove') {
        const obstObj = obstGroup.children.find((obst: any) => {
            return obst.obstId === object
        });
        const stepValue = stepDir === -1 ? older : newer;
        if (!obstObj) return;
        SetObstPosition(obstObj, stepValue, roofRotY);
        self.refreshShade();
    } else if (key === 'treeMove') {
        object.forEach((treeId: any, idx: number) => {
            const selTree = treeGroup.children.find((tree: any) => {
                return tree.obstId === treeId
            });
            if (!selTree) return;
            const oldPos = older[idx], newPos = newer[idx];
            const stepValue = stepDir === -1 ? oldPos : newPos;
            selTree.position.set(stepValue.x, stepValue.y, stepValue.z);
        });
        self.refreshShade();
    }
    else if (key === 'obstCreate') {
        const index = obstGroup.children.findIndex((obst: any) => obst.obstId === object.obstId);
        if (index !== -1) {
            obstGroup.children.splice(index, 1);
        } else {
            obstGroup.children.push(object);
        }
        self.refreshShade();
    } else if (key === 'obstAngle') {
        const selGroup: any = self.obstGroup.children.find((item: any) => item.obstId === object);
        const inGroup = selGroup.children[0].children[0];
        const obstMesh = inGroup.children[0]
        if (inGroup.rotation.x !== obstMesh.rotX) inGroup.rotation.x = obstMesh.rotX;
        obstMesh.verFloor = !obstMesh.verFloor
        self.refreshShade()
    } else if (key === 'obstShape') {
        const shapeNo = (stepDir === -1 ? older : newer);
        self.obstId = object;
        self.setObstShape(shapeNo);
        self.refreshShade();
    } else if (key === 'treeCreate') {
        const index = treeGroup.children.findIndex((tree: any) => tree.obstId === object.obstId);
        if (index !== -1) {
            treeGroup.children.splice(index, 1);
        } else {
            treeGroup.children.push(object);
        }
        self.refreshShade();
    } else if (key === 'material') {
        const selMeshArr: any[] = [];
        object.forEach((uuid: any) => {
            self.modelGroup.traverse((child: any) => {
                if (child.uuid === uuid) selMeshArr.push(child);
            });
        });
        selMeshArr.forEach((mesh, idx) => {
            const stepValue = stepDir === -1 ? older[idx] : newer[idx];
            const { map, color } = stepValue;
            if (map && !color) mesh.material = new THREE.MeshStandardMaterial({ map });
            else if (!map && color) mesh.material = new THREE.MeshStandardMaterial({ color });
        });
    } else if (key === 'module') {
        const modeStr = (stepDir === -1) ? older : newer;
        useViewerStore.setState({ savedRoofModulesLayout: JSON.parse(modeStr) });
        const layout = useViewerStore.getState().savedRoofModulesLayout || [];
        const showLabel = useViewerStore.getState().isModuleMultiplierLabelVisible;
        // clear existing modules first
        self.roofMeshArr.forEach(roof => {
            roof.children.filter((c: any) => c.module).forEach((m: ModuleMesh) => {
                const idx = self.meshArr.findIndex(mm => mm.moduleId === m.moduleId);
                if (idx !== -1) self.meshArr.splice(idx, 1);
                const idx2 = self.moduleMeshArr.findIndex(mm => mm.moduleId === m.moduleId);
                if (idx2 !== -1) self.moduleMeshArr.splice(idx2, 1);
                roof.remove(m);
            });
        });
        layout.forEach((entry: any) => {
            const roofMesh = self.roofMeshArr.find(r => r.roofFaceId === entry.roofFaceId);
            if (!roofMesh) return;
            entry.moduleArr.forEach((item: any) => {
                AddIndividualMode(roofMesh, item, true, self.moduleMeshArr, self.meshArr, showLabel);
            });
        });
        SwitchModuleIrrMat(self, true);
        self.refreshShade();

    } else if (key === 'togglePathway') {
        self.togglePathway(object);
    } else if (key === 'mapMove') {
        const position = (stepDir === -1) ? older : newer;
        self.mapCustom?.position.set(position.x, position.y, position.z);
    }
    else if (key === 'drawFace' || key === 'deleteFace') {
        const roofs = self.roofs[0];
        if ((stepDir === -1 && key === 'drawFace') || (stepDir === 1 && key === 'deleteFace')) {
            // Undo face creation/ Redo face deletion -> Remove new face & edges
            roofs.faces = roofs.faces.filter((item: any) => item.roofFaceId !== object.newFace.roofFaceId);
            roofs.edges = roofs.edges.filter((item: any) => item.roofFaceId !== object.newFace.roofFaceId);
        } else {
            // Undo face deletion/ Redo face creation -> Add new face & edges
            roofs.faces.push(object.newFace);
            roofs.edges.push(...object.newEdges);
        }
        drawDesign(self);
        SwitchModuleIrrMat(self, true);
        self.refreshShade();
    } else if (key === 'updatePlaneRoof') {
        const { property, selRoofId } = object;
        const value = (stepDir === -1) ? older : newer;
        self.selFlatRoof = self.roofMeshArr.find(item => item.roofFaceId === selRoofId);
        UpdatePlaneRoof(self, property, value, true);
    }

    self.stepNum += stepDir;
    SetStepButton(self.stepMax, self.stepNum);
}

export function SetStepButton(stepMax: number, stepNum: number) {
    const btnStepUndo = document.getElementsByClassName('btnStepUndo')[0],
        btnStepRedo = document.getElementsByClassName('btnStepRedo')[0];
    if (stepNum > -1) btnStepUndo?.classList.remove('disabled');
    else btnStepUndo?.classList.add('disabled');
    if (stepNum === stepMax) btnStepRedo?.classList.add('disabled');
    else btnStepRedo?.classList.remove('disabled');
}
